import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-2 mt-2 lg:mt-0 rounded shadow bg-white" }
const _hoisted_2 = {
  key: 0,
  class: "p-6 center"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "p-6" }
const _hoisted_5 = { class: "text-xl font-bold" }
const _hoisted_6 = {
  key: 0,
  class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start"
}
const _hoisted_7 = {
  key: 1,
  class: "pt-2 text-gray-600 text-xs lg:text-sm flex items-center justify-center lg:justify-start"
}
const _hoisted_8 = { class: "p-2 mt-2 rounded shadow bg-white" }
const _hoisted_9 = ["innerHTML"]

import moment from "moment";

import Topic from "@/models/Topic";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopicDetail',
  setup(__props) {

// import { defineComponent } from "vue";
const store = useStore();
const route = useRoute();

// interface TopicDetailState {
//   // is_loading: boolean;

//   topic: Topic;
// }

// export default defineComponent({
//   name: "TopicDetail",

//   data() {
//     return {
//       // is_loading: false,

const topic = ref<Topic>({} as Topic);
//     } as TopicDetailState;
//   },

//   mounted() {
//     this.refresh();
//   },

onMounted(() => {
  refresh();
});

//   methods: {
const formatDate = (date: Date, format: string) => {
  return moment(date).format(format);
};

const refresh = () => {
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);

  const id = route.params.topic_id as string;

  setTimeout(async () => {
    try {
      console.log(id);
      topic.value = await Topic.get(id);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};
//   },
// });

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (topic.value.type != 'information')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: topic.value.main_image_url,
              width: "240"
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(topic.value.title ?? ""), 1),
        (topic.value.publish_from || topic.value.publish_to)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createElementVNode("span", null, [
                _createVNode(_component_fa, {
                  icon: "calendar",
                  class: "text-sm text-color-3 mr-2"
                })
              ]),
              _createTextVNode(" " + _toDisplayString(`${topic.value.publish_from ? formatDate(topic.value.publish_from, "YYYY-MM-DD") : "-"} ~ ${topic.value.publish_to ? formatDate(topic.value.publish_to, "YYYY-MM-DD") : "-"}`), 1)
            ]))
          : _createCommentVNode("", true),
        (topic.value.type != 'information')
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
              _createElementVNode("span", null, [
                _createVNode(_component_fa, {
                  icon: "eye",
                  class: "text-sm text-color-3 mr-2"
                })
              ]),
              _createTextVNode(" " + _toDisplayString(`${topic.value.view_count ?? "-"} / ${topic.value.click_count ?? "-"}`), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        innerHTML: topic.value.body
      }, null, 8, _hoisted_9)
    ])
  ], 64))
}
}

})